import { FunctionComponent, memo } from 'react';

import { useTranslation } from 'react-i18next';
import FormattedMessage from '../../../../../../../utils/components/FormattedMessage';
import {
  SupportOutreachTriggerFormFields,
  SupportTriggerRendererProps,
} from '../../../../../types';
import useFormControls from '../../../hooks/useFormControls';
import { FormikSupportOutreachTriggerValue } from '../support/types';
import { getTriggerFooterProperty } from './config';

const SupportGenericTriggerFooter: FunctionComponent<SupportTriggerRendererProps<
  FormikSupportOutreachTriggerValue,
  any
>> = ({ field, form, renderDropdownFor, triggerType }) => {
  const { getPropertyValue } = useFormControls<
    FormikSupportOutreachTriggerValue
  >(field, form);
  const { t } = useTranslation();
  const summary = [
    SupportOutreachTriggerFormFields.IssueTriggeredWhen,
    SupportOutreachTriggerFormFields.IssueClearedWhen,
    SupportOutreachTriggerFormFields.SendClearEmailWhenIssueCleared,
  ];

  const renderSummary = () => {
    return summary.map((item) => {
      const property = getTriggerFooterProperty(triggerType, item);
      let formPropertyValue = getPropertyValue(item) as any;
      if (typeof formPropertyValue == 'boolean') {
        formPropertyValue = formPropertyValue
          ? t('genericLabels.yes')
          : t('genericLabels.no');
      }
      const value = t(property.valueCopyId)?.replace(
        `{${item}}`,
        formPropertyValue !== undefined && !isNaN(formPropertyValue)
          ? formPropertyValue
          : 'n/a ',
      );
      return (
        <p key={item}>
          <FormattedMessage id={property.nameCopyId} />
          <span className="OutreachContainer__subscriber-outreach-trigger-info-value">
            {value}
          </span>
        </p>
      );
    });
  };

  return (
    <div className="OutreachContainer__subscriber-outreach-trigger-row OutreachContainer__subscriber-outreach-trigger-info">
      {renderSummary()}
    </div>
  );
};

export default memo(SupportGenericTriggerFooter);
